"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiKeyForm = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var Error_1 = require("./components/Error");
var dispatchers_1 = require("./utils/dispatchers");
var getConnectState = function (state) {
    return state.vektorio.connect.linkableProjectsStatus;
};
var getErrorsState = function (state) { return state.vektorio.connect.errors; };
var ApiKeyForm = function (props) {
    var dispatchers = (0, dispatchers_1.mapDispatchers)((0, react_redux_1.useDispatch)());
    var linkableProjectsStatus = (0, react_redux_1.useSelector)(getConnectState);
    var errors = (0, react_redux_1.useSelector)(getErrorsState);
    var RefreshIcon = React.createElement(sok_ui_1.Icon, { className: 'fa-sync' });
    var inputOnChange = function (_a) {
        var value = _a.target.value;
        return props.setApiKey(value);
    };
    var connectButtonDisabled = linkableProjectsStatus.isBusy;
    return (React.createElement("div", { className: 'api-key' },
        React.createElement("h3", null, (0, translation_1.getLocalization)('vektorio/connectHeader')),
        React.createElement("label", null, (0, translation_1.getLocalization)('vektorio/insertApiKey')),
        React.createElement(sok_ui_1.TextInput, { value: props.apiKey, onChange: inputOnChange }),
        React.createElement(Error_1.Error, { errors: errors, field: 'apiKey' }),
        React.createElement(sok_ui_1.Button, { color: 'green', iconRight: RefreshIcon, disabled: connectButtonDisabled, onClick: dispatchers.fetchLinkable(props.apiKey) }, (0, translation_1.getLocalization)('vektorio/fetchProjects'))));
};
exports.ApiKeyForm = ApiKeyForm;
